import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { fetchPrivacy, fetchPrivacyCcpa, fetchServiceAddendums } from '../../ducks/strapi.duck';

export const ASSET_NAME = 'privacy-policy-custom';

export const loadData = (params, search) => dispatch => {
  const pageAsset = { [ASSET_NAME]: `content/pages/${ASSET_NAME}.json` };
  // Fetch hosted page asset first
  const hosted = dispatch(fetchPageAssets(pageAsset, true));

  // Also fetch the CMS-driven privacy sections so they are available during SSR
  const cmsFetches = Promise.all([
    dispatch(fetchPrivacy({})),
    dispatch(fetchPrivacyCcpa({})),
    dispatch(fetchServiceAddendums({})),
  ]);

  return Promise.all([hosted, cmsFetches]);
};
